import { type Common } from './common.js';
import {
  type EntityId,
  type Fingerprint,
  type OutputKind,
  type RuleGroup,
  type SearchId,
} from './models/fingerprint/conjecture.js';
import { type Event } from './models/fingerprint/event.js';

export class API {
  common: Common;
  baseEndpoint = '/fingerprint';

  constructor(common: Common) {
    this.common = common;
  }

  async construct(entityId: EntityId): Promise<Fingerprint> {
    const url = this.common.constructPath(this.baseEndpoint, entityId);
    return await this.common.getJSON(url);
  }

  async findEvent(id: string): Promise<Event> {
    const url = this.common.constructPath(`${this.baseEndpoint}/events/${id}`);
    return await this.common.getJSON(url);
  }

  async test(entityId: SearchId, scenarioId: string): Promise<RuleGroup[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/test`);
    return await this.common.postJSON(url, { ...entityId, scenarioId });
  }

  async query(options: {
    encounterIds?: string[];
    ehrInformationIds?: string[];
    patientOrderIds?: string[];
    outputs: OutputKind[];
    queryOnly?: boolean;
    ignoreTestStatus?: boolean;
  }) {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, options);
  }
}
